import React from 'react';

/**
 * Page frame. Owns the max width, the horizontal gutters and — critically —
 * the bottom padding that keeps content clear of the fixed mobile tab bar.
 *
 * Screens should not set their own `container mx-auto` any more; they render
 * their content and let this decide the measure.
 *
 * `bleed` opts a page out of the width cap (used by full-bleed headers that
 * manage their own inner container).
 */
const AppShell = ({ children, bleed = false, className = '' }) => (
  <main
    className={[
      'min-h-[calc(100dvh-var(--nav-height))]',
      // Clears the bottom nav on mobile; no reserved space once it's hidden at lg.
      'pb-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom,0px)+1rem)] lg:pb-10',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {bleed ? children : <div className="mx-auto w-full max-w-7xl px-4 py-5 sm:px-6 sm:py-6">{children}</div>}
  </main>
);

/** Standard inner container for pages that render their own full-bleed header. */
export const ShellContainer = ({ children, className = '' }) => (
  <div className={`mx-auto w-full max-w-7xl px-4 py-5 sm:px-6 sm:py-6 ${className}`}>{children}</div>
);

export default AppShell;
